module.exports = __webpack_public_path__ + "img/icon_location.5f9d7977.svg";